export default {
  header: {
    title: 'Announcements',
    description: '',
  },
  data_table: {
    title: '',
    button_create: 'create announcement',
    menu_actions: {
      edit: 'edit',
      delete: 'delete',
    },
    delete_dialog: {
      title: 'Are you sure you want to delete announcement?',
      button_yes: 'Delete',
      button_no: 'Cancel',
    },
  },
  form_labels: {
    title: 'Title',
    announcement_url: 'Announcement URL',
    description: 'Description',
    button_text: 'Button Text',
    image: 'Upload image',
  },
  form_edit_dialog: {
    title_create: 'create new announcement',
    title_update: 'Edit announcement',
    button_create: 'create announcement',
    button_update: 'Save Announcement',
    button_close: 'close',
  },
  form_edit_block: {
    button_upload: 'upload image',
  },
  alert: {
    created_successfully: 'Announcement created successfully',
    updated_successfully: 'Announcement updated successfully',
    deleted_successfully: 'Announcement deleted successfully',
  },
  button_mark_all_as_read: 'Mark all as read',
};
